export default __webpack_public_path__ + "static/media/pointing_img.9bbc2f42.png";